class FormCustomDropdown extends HTMLElement {
  constructor() {
    super();

    this.contants = {
      selectedClass: {
        show: 'show-dropdown',
        hide: 'hidden-dropdown',
        initial: 'initial-state'
      }
    }

    this.selectedElement = this.querySelector('.js-dropdown-selected');
    this.listElement = this.querySelector('.js-dropdown-list');
    this.hiddenInput = this.querySelector('input[type="text"]');
    this.listItems = this.listElement?.querySelectorAll('li');

  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.selectedElement.addEventListener('click', () => {
      this.toggleDropdown();
    });

    this.listElement.addEventListener('click', (e) => {
      if (e.target.closest('li')) {
        this.selectItem(e.target.closest('li'));
        this.selectedElement.classList.remove(this.contants.selectedClass.initial);
      }
    })

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.closeDropdown();
      }
    });
  }

  toggleActiveClass() {
    const {show: showClass, hide: hideClass} = this.contants.selectedClass;

    if (this.selectedElement.classList.contains(showClass)) {
      this.selectedElement.classList.remove(showClass);
      this.selectedElement.classList.add(hideClass);
    } else {
      this.selectedElement.classList.add(showClass);
      this.selectedElement.classList.remove(hideClass);
    }
  }

  toggleDropdown() {
    const isOpen = this.listElement.style.display === 'block';
    this.listElement.style.display = isOpen ? 'none' : 'block';
    this.toggleActiveClass();
  }

  closeDropdown() {
    this.listElement.style.display = 'none';
    this.selectedElement.classList.remove(this.contants.selectedClass.show);
  }

  selectItem(item) {
    this.selectedElement.textContent = item.textContent;
    this.hiddenInput.value = item.dataset.value;
    this.closeDropdown();
    // this.toggleActiveClass();
  }
}

if (customElements && !customElements.get('form-custom-dropdown')) {
  customElements.define('form-custom-dropdown', FormCustomDropdown);
}

